import React, { useEffect } from "react";
import { useLazyGetFilteredAssetRequestsQuery } from "../../../features/assetrequest/assetReqApiSlice";

// Helper function to check if filters have meaningful values
const hasValidFilters = (filters) => {
  if (!filters) return false;
  
  // Check if any filter has a non-empty value
  for (const [key, value] of Object.entries(filters)) {
    if (Array.isArray(value)) {
      // For arrays, check if they have items
      if (value.length > 0) return true;
    } else if (typeof value === 'string') {
      // For strings, check if they're not empty
      if (value.trim() !== '') return true;
    } else if (value !== null && value !== undefined) {
      // For other values, check if they exist
      return true;
    }
  }
  return false;
};

const FilteredAssetReqFetcher = ({ filters, onDataFetched }) => {
  const [fetchAssetRequests, { data, isLoading }] = useLazyGetFilteredAssetRequestsQuery();

  useEffect(() => {
    if (hasValidFilters(filters)) {
      fetchAssetRequests({ page: 1, limit: 99999, filters });
    }
  }, [filters]);

  useEffect(() => {
    if (data && onDataFetched) {
      onDataFetched(data);
    }
  }, [data]);

  return null; // no UI rendered
};

export default FilteredAssetReqFetcher;